import { Divider } from "Components";
import { useMobileMediaQuery } from "hooks";
import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

export const Loader: React.FC = () => {
  const isMobile = useMobileMediaQuery();

  return (
    <Container>
      <Top>
        <Skeleton height={25} width={250} />
        <DescriptionSkeleton height={25} />
      </Top>
      <Divider />
      <BarChartSkeleton height={300} />
      <Skeleton height={isMobile ? 50 : 30} />
      <Divider />
      <Bottom>
        <Skeleton height={20} width={190} />
        <BottomItems>
          {Array.from({ length: 2 }, (_, i) => i).map((idx) => (
            <BottomItem key={`activity-loader-${idx}`}>
              <Skeleton height={15} width={90} />
              <Skeleton height={15} width={30} />
              <Skeleton height={15} width={140} />
            </BottomItem>
          ))}
        </BottomItems>
      </Bottom>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  gap: 10px;
  width: 100%;
  height: 100%;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const DescriptionSkeleton = styled(Skeleton)`
  max-width: 550px;
`;

const BarChartSkeleton = styled(Skeleton)`
  border-radius: 7px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const BottomItems = styled.div`
  display: flex;
  gap: 24px;
`;

const BottomItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
